import { registerCapability } from '../../platform/capability-registry';
import { MaasGatewayNodesBlock } from './MaasGatewayNodesBlock';
import { MAAS_GATEWAY_NODES_FIELD_KEY_LIST } from './fieldKeys';
import { resolveMaasNodeGroupsPaths } from './resolvePaths';
import type { MaasNodeGroupsBlockOptions } from './types';

registerCapability<MaasNodeGroupsBlockOptions>({
  key: 'maas-gateway-nodes',
  fields: [...MAAS_GATEWAY_NODES_FIELD_KEY_LIST],
  component: MaasGatewayNodesBlock,
  defaultPaths: (prefix) => resolveMaasNodeGroupsPaths(prefix),
  resolvePaths: (prefix) => resolveMaasNodeGroupsPaths(prefix),
});
